/**
 * /control-plane/$spokeId — Surface Layer (/01)
 *
 * Scoped Developer Hub (operator) spoke view. Replaces the earlier
 * sample-adoption scaffolding so no Carbon sample placeholder copy leaks into a
 * live operator route. The granular per-spoke operator surface is not built
 * yet — shown honestly with a scoped, non-faked state that points back to the
 * Developer Hub cockpit.
 */

import { createFileRoute } from '@tanstack/react-router';
import { InlineNotification } from '@carbon/react';
import { SurfacePageHeader } from '../components/shell/SurfacePageHeader';
import '../styles/views.scss';

export const Route = createFileRoute('/control-plane/$spokeId')({
  component: ControlPlaneSpokeView,
});

function ControlPlaneSpokeView() {
  const { spokeId } = Route.useParams();
  return (
    <div className="view">
      <SurfacePageHeader title="Developer Hub spoke" subtitle="Scoped operator spoke view." tag="DevHub" />
      <InlineNotification
        kind="info"
        lowContrast
        hideCloseButton
        title="Scoped spoke view is being built"
        subtitle={`The operator view for spoke "${spokeId}" is not yet available. Use the Developer Hub cockpit for tenant requests, ActionFrames, traces and FinOps.`}
      />
    </div>
  );
}
